import React from "react";
import { Container, Typography, Box, List, ListItem, ListItemIcon, ListItemText, Divider, Alert } from "@mui/material";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faMapMarkedAlt, faCalendarAlt, faChevronRight, faUsers, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

const POST20240618: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />
            <Box mt={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    Alerte rouge sur le PLUi de Bois-le-Roi
                </Typography>
            </Box>
            <Typography variant="subtitle1" gutterBottom>
                Ce que vous devez savoir sur la partie du PLUi concernant BLR portée par le Maire&nbsp;!
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="body1" paragraph>
                Lors de la première réunion publique sur le PLUi du <b>15 juin 2024</b>, le Maire a annoncé&nbsp;:
            </Typography>
            <List dense>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faChevronRight} color="#1976d2" />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <>
                                <b>Une seule règle commune</b> s’appliquera sur l’ensemble de la commune pour les logements collectifs à construire&nbsp;:
                            </>
                        }
                        secondary={
                            <List sx={{ pl: 2 }}>
                                <ListItem>
                                    <ListItemIcon>
                                        <FontAwesomeIcon icon={faUsers} color="#1976d2" />
                                    </ListItemIcon>
                                    <ListItemText primary="3 à 15 logements envisagés : 80%* de LLS obligatoire (Logements Locatifs Sociaux)" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <FontAwesomeIcon icon={faUsers} color="#1976d2" />
                                    </ListItemIcon>
                                    <ListItemText primary="Plus de 16 logements : 75%* de LLS obligatoire" />
                                </ListItem>
                                <Typography variant="caption" color="text.secondary" sx={{ pl: 7 }}>
                                    *avec arrondi à l’unité supérieure, dixit le Maire – 18/06/2024
                                </Typography>
                            </List>
                        }
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faChevronRight} color="#1976d2" />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <>S&apos;ajoutent à cela :</>
                        }
                        secondary={
                            <List sx={{ pl: 2 }}>
                                <ListItem>
                                    <ListItemIcon>
                                        <FontAwesomeIcon icon={faMapMarkedAlt} color="#43a047" />
                                    </ListItemIcon>
                                    <ListItemText primary="18 secteurs nommés « de mixité sociale » définis unilatéralement sur des parcelles privées, imposant dès le premier logement 80%* de LLS." />
                                </ListItem>
                            </List>
                        }
                    />
                </ListItem>
            </List>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2, pl: 4 }}>
                <FontAwesomeIcon icon={faMapMarkedAlt} /> Vous pouvez visualiser ces secteurs sur la carte graphique via « secteur à programme de logements mixité sociale en zone U et AU ».
            </Typography>
            <Typography variant="body1" paragraph>
                <b>Lors de la deuxième réunion du 18 juin,</b> le nombre de secteurs « de mixité sociale » est passé à <b>23</b>.
            </Typography>
            <Typography variant="body2" paragraph>
                Ce type de projet est susceptible d&apos;être confié à un établissement comme l&apos;<b>EPFIF</b> (Établissement Public Foncier d’Île de France), actuellement partenaire de la CAPF.
            </Typography>

            <Alert severity="warning" icon={<FontAwesomeIcon icon={faQuestionCircle} style={{ fontSize: 20 }} />}>
                Comment ne pas y voir une atteinte au droit à la propriété ?
            </Alert>
            <Typography variant="body2" sx={{ mt: 1 }}>
                Le Maire, qui vante une concertation, n’a même pas informé les propriétaires spoliés.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" color="primary" sx={{ mb: 2 }}>
                <FontAwesomeIcon icon={faCalendarAlt} /> Planning à retenir :
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCalendarAlt} color="#1976d2" />
                    </ListItemIcon>
                    <ListItemText
                        primary="24 juin & 26 juin à 19h30"
                        secondary="Réunions publiques en Mairie"
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCalendarAlt} color="#1976d2" />
                    </ListItemIcon>
                    <ListItemText
                        primary="27 juin 2024"
                        secondary="Conseil de la CAPF : 1er arrêt du PLUi – Tous les documents accessibles sur le site de la CAPF"
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCalendarAlt} color="#1976d2" />
                    </ListItemIcon>
                    <ListItemText
                        primary="19 septembre 2024"
                        secondary="Conseil Municipal : Validation de la partie du PLUi concernant BLR"
                    />
                </ListItem>
            </List>

            <Box mt={3}>
                <Alert severity="info">
                    Nous vous invitons à venir <b>nombreux</b> aux deux réunions pour demander des explications au Maire.
                </Alert>
            </Box>
        </Container>
    );
};

export default POST20240618;